export default __webpack_public_path__ + "static/media/paperwork.92983c32.jpg";